import React from "react";
import {
  LuRocket,
  LuHandHeart,
  LuExternalLink,
  LuBookText,
} from "react-icons/lu";
import { Link } from "@reach/router";

const CatalogueCard = ({
  type,
  name,
  description,
  link,
  documentLink,
  onClick,
}) => {
  return (
    <div className="catalogue-card">
      <div className="card-body">
        <div className="flex-between">
          <div class="icon">
            {type === "Application" || type === "Product" ? (
              <LuRocket className="text-dark fs-3" />
            ) : (
              <LuHandHeart className="text-dark fs-3" />
            )}
          </div>
          <div>
            {documentLink && (
              <a
                href={documentLink}
                target="_blank"
                rel="noopener noreferrer"
                className="me-2"
                onClick={(e) => e.stopPropagation()}
              >
                <LuBookText />
              </a>
            )}
            {link && (
              <a
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className="me-2"
                onClick={(e) => e.stopPropagation()}
              >
                <LuExternalLink />
              </a>
            )}
          </div>
        </div>
        <h3 className="ellipsis">{name}</h3>
        <p className="ellipsis">{description}</p>
      </div>
    </div>
  );
};

export default CatalogueCard;
